export function numberFormat(number: number): string {
  return Intl.NumberFormat('pt-BR').format(number)
}
